/**
 * This function is used to create a collapse id to store the collapsed state of a table in the Redux store.
 * For structured tables, we use provenance uuid's, but legacy tables don't have provenance uuid's so we
 * instead construct this custom collapse id.
 * @param fileId
 * @param tableName
 */
export function createCollapseId(fileId: string, tableName: string): string {
  return `${fileId}-${tableName}`;
}
